import {Checkbox} from '@mui/material';
import {Controller, useWatch} from 'react-hook-form';
import React, {useEffect, useRef} from 'react';
import AppButton from '../../../../../../../../../components/common/AppButton';
import {SVG} from '../../../../../../../../../constants/assetLists';

type Props = {
  index: number;
  srNo: string;
  control: any;
  OnRemove: (index: number) => void;
  setValue: any;
  autoFocus?: boolean;
};

function ChecklistBox({
  index,
  srNo,
  control,
  OnRemove,
  setValue,
  autoFocus,
}: Props) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const isChecked = useWatch({
    control,
    name: `list.${index}.status`,
  });

  useEffect(() => {
    if (autoFocus && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="flex justify-between items-center gap-3 px-2 py-1 border-b border-b-lightDarkGray group hover:bg-softAquaLight">
      <div className="flex-1 flex items-center gap-1">
        <p className="m-0 text-[20px] font-light text-gray w-[40px]">{srNo}</p>

        <div className="flex-1 flex items-center gap-2">
          <Controller
            control={control}
            name={`list.${index}.status`}
            render={({field}) => {
              return (
                <Checkbox
                  color="secondary"
                  size="small"
                  sx={{p: 1}}
                  checked={field.value}
                  {...field}
                />
              );
            }}
          />

          <Controller
            control={control}
            name={`list.${index}.instruction`}
            render={({field: {value}}) => {
              return (
                <textarea
                  ref={textareaRef}
                  value={value}
                  onChange={e => {
                    setValue(`list.${index}.instruction`, e.target.value, {
                      shouldDirty: true,
                      shouldValidate: true,
                    });
                  }}
                  rows={1}
                  autoComplete="off"
                  onInput={e => {
                    e.currentTarget.style.height = 'auto';
                    e.currentTarget.style.height =
                      e.currentTarget.scrollHeight + 'px';
                  }}
                  className={`border-none outline-none bg-transparent text-[20px] font-medium leading-[20px] extraSmall:w-[110px] sm:flex-1 overflow-hidden resize-none ${
                    isChecked ? 'text-black' : 'text-gray'
                  }`}
                  style={{
                    padding: 0,
                    margin: 0,
                    lineHeight: '20px',
                  }}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="hidden group-hover:flex items-center gap-3">
        <button
          className="w-[16px] h-[18px]"
          onClick={() => {
            OnRemove(index);
          }}>
          <img
            src={SVG.listDeleteIcon}
            alt="delete"
            className="w-full h-full object-contain"
          />
        </button>

        <AppButton className="px-3 py-2">
          <img
            src={SVG.checkGrayIcon}
            alt="edit"
            className="w-[12px] h-[10px] object-contain"
          />
        </AppButton>
      </div>
    </div>
  );
}

export default React.memo(ChecklistBox);
